import { defineComponent as g, computed as f, openBlock as s, createElementBlock as o, createElementVNode as a, normalizeClass as t, withDirectives as r, vModelCheckbox as u, toDisplayString as n, createCommentVNode as y } from "vue";
import { _ as v } from "../_plugin-vue_export-helper-CHgC5LLL.js";
import '../Toggle.css';const h = {
  key: 0,
  class: "flex items-center cursor-pointer"
}, k = ["disabled"], w = {
  key: 0,
  class: "text-base text-app-gray-600 dark:text-app-gray-100"
}, V = { key: 0 }, _ = { key: 1 }, D = ["disabled"], E = /* @__PURE__ */ g({
  __name: "Toggle",
  props: {
    modelValue: { type: Boolean, default: !1 },
    size: { default: "large" },
    labelEnabled: { default: "" },
    labelDisabled: { default: "" },
    showLabel: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(p, { emit: b }) {
    const c = p, m = b, l = f({
      get() {
        return c.modelValue;
      },
      set(e) {
        m("update:modelValue", e);
      }
    });
    return (e, d) => e.size === "small" ? (s(), o("div", h, [
      a("label", {
        class: t(["switch rounded-full cursor-pointer", [l.value ? "bg-app-success" : "bg-app-gray-400", { "mr-2": e.showLabel, "!cursor-not-allowed !bg-app-gray-200": e.disabled }]])
      }, [
        r(a("input", {
          "onUpdate:modelValue": d[0] || (d[0] = (i) => l.value = i),
          disabled: e.disabled,
          type: "checkbox",
          class: "sr-only peer"
        }, null, 8, k), [
          [u, l.value]
        ]),
        a("div", {
          class: t(["knob w-3 h-3 bg-app-white rounded-full", { "float-right": l.value }])
        }, null, 2)
      ], 2),
      e.showLabel ? (s(), o("div", w, [
        l.value ? (s(), o("span", V, n(e.labelEnabled || "Enabled"), 1)) : (s(), o("span", _, n(e.labelDisabled || "Disabled"), 1))
      ])) : y("", !0)
    ])) : (s(), o("label", {
      key: 1,
      class: t(["toggle cursor-pointer", [`${e.size}`, { "!cursor-not-allowed": e.disabled }]]),
      style: { width: "300px" }
    }, [
      r(a("input", {
        "onUpdate:modelValue": d[1] || (d[1] = (i) => l.value = i),
        disabled: e.disabled,
        type: "checkbox",
        class: "sr-only peer"
      }, null, 8, D), [
        [u, l.value]
      ]),
      a("div", {
        class: t(["toggle-tab", l.value ? "selected" : "unselected"])
      }, n(e.labelEnabled || "Select"), 3),
      a("div", {
        class: t(["toggle-tab", l.value ? "unselected" : "selected"])
      }, n(e.labelDisabled || "Unselect"), 3)
    ], 2));
  }
}), C = /* @__PURE__ */ v(E, [["__scopeId", "data-v-3709f66c"]]);
export {
  C as default
};
//# sourceMappingURL=Toggle.esm.js.map
